export enum StatusOfTask {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2
}
